export const connectionGuides = [
  {
    id: "claude", name: "Claude", label: "Custom connector",
    intro: "Connect from Claude’s web connector settings. Your plan and organization controls determine which options appear.",
    steps: [
      "Open Customize → Connectors in Claude. Choose +, then Add custom connector. In an organization, an owner may need to add it first in Organization settings → Connectors.",
      "Name the connector Heartily and paste the server address shown here. Use the automatic OAuth setup; Heartily supports dynamic client registration, so you do not need to supply a shared client secret.",
      "Choose Connect, sign in to Heartily, check the account shown, and select Allow access.",
      "In a conversation, open + → Connectors and enable Heartily. Ask it to list your courses to confirm the connection."
    ],
    source: "https://support.claude.com/en/articles/11175166-get-started-with-custom-connectors-using-remote-mcp"
  },
  {
    id: "chatgpt", name: "ChatGPT", label: "Developer-mode app",
    intro: "Use ChatGPT on the web with custom MCP apps enabled. Access and menu labels vary by plan and workspace; an administrator may need to enable or publish the app.",
    steps: [
      "Enable Developer mode in Settings → Security and login. Some accounts show it under Apps → Advanced Settings instead.",
      "Open Plugins (or Apps in your account), choose + or Create, and add a remote MCP app named Heartily using the server address shown here.",
      "Select OAuth and dynamic client registration (DCR) if offered. Heartily does not require a manually supplied client secret. Complete Heartily sign-in and approve the account’s read-only access.",
      "Finish creating the app after its tools load. In a new chat, choose Developer mode from the + menu and select Heartily. Ask it to list your courses."
    ],
    source: "https://developers.openai.com/api/docs/guides/developer-mode"
  },
  {
    id: "grok", name: "Grok", label: "Custom MCP connector",
    intro: "Grok’s web connector flow supports custom MCP servers. Business and Enterprise workspaces may require an admin to provision the connector first.",
    steps: [
      "Visit grok.com/connectors while signed in to Grok.",
      "Choose New Connector → Custom and enter the Heartily server address shown here.",
      "Complete the OAuth prompt in Heartily. Check the signed-in account and select Allow access.",
      "Once Grok discovers the tools, ask it to use Heartily to list your courses or your linked students."
    ],
    source: "https://docs.x.ai/grok/connectors"
  },
  {
    id: "grok-bot", name: "Grok Bot", label: "Custom setup required",
    intro: "Grok Bot supports connectors through Plugins, but its official guide does not document a universal custom-URL setup screen. Heartily is not a published marketplace plugin.",
    steps: [
      "Open Settings → Plugins to review the connectors available to your account. Do not assume Heartily is already listed.",
      "Ask your Bot: “Can you add a custom remote MCP server called Heartily at {serverUrl}, with OAuth sign-in?” This is a setup request, not a guaranteed one-click installer.",
      "If your Bot or administrator can configure an OAuth-capable remote MCP connection, complete Heartily’s browser consent. Do not paste your password or an access token into chat.",
      "Attach the installed connector with @ and ask it to list your courses. If custom MCP setup is unavailable, use the Grok web connector instructions instead."
    ],
    note: "Grok Bot’s installed connectors are available across your Bots. A browser login is a different connection and does not inherit Heartily MCP’s read-only restriction.",
    source: "https://docs.x.ai/grok-bot/computer-and-apps"
  },
  {
    id: "other", name: "Other clients", label: "Remote MCP + OAuth",
    intro: "Use an assistant that supports remote Streamable HTTP MCP servers, OAuth discovery, and dynamic client registration. A service accepting only local commands or static API keys needs additional integration work.",
    steps: [
      "Add a remote HTTP MCP server named Heartily and paste the server address shown here.",
      "Choose OAuth authentication and automatic client registration. If advanced settings are needed, the permission scope is mcp:read and the resource is the exact server address.",
      "Sign in to Heartily in the browser, review the account and permissions, and allow access.",
      "Enable the four Heartily tools and ask for your courses. For a parent account, first list your linked students and choose one."
    ],
    source: "https://modelcontextprotocol.io/specification/2025-11-25/basic/authorization"
  }
]
